<template>
  <div class="pdf-doc">
    <div v-show="done === true">
      <pdf
        style="width: 100%; max-width: 1200px;"
        class="m-x-auto"
        v-for="(i, k) in numPages"
        :id="`pdf-${i}`"
        :src="documentPdf"
        @loaded="loaded"
        :page="i"
        :key="k"
      />
    </div>
    <div v-show="done === false"><h6>Загрузука PDF...</h6></div>
  </div>
</template>
<script>
import pdf from "vue-pdf";

export default {
  mounted() {
    this.documentPdf = pdf.createLoadingTask(this.src);
    this.documentPdf.promise.then((pdf) => {
      this.numPages = pdf.numPages;
    });
  },
  components: {
    pdf,
  },
  computed:{
    val: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  props: {
    value: {
      default: function () {
        return false;
      },
    },
    src: {
      default: function () {
        return "";
      },
    },
  },
  methods: {
    loaded() {
      this.done = true;
      this.val = this.done
    },
  },
  data() {
    return {
      documentPdf: null,
      numPages: 0,
      done: false,
    };
  },
};
</script>
<style>
.pdf-doc {
  overflow: hidden;
}
</style>

